// extracted by mini-css-extract-plugin
module.exports = {"form-container":"user_form-container__zVDhS","margin-b-10":"user_margin-b-10__nIa2G","error":"user_error__3Cx_X"};